import {Stack, Typography} from "@mui/material";
import React from 'react';
import LanguageHandler from "../translations/LanguageHandler";

const Home = () => {
    return (
        <Stack direction="column" padding="20px">
            <Typography variant="body1" padding="10px 0">
                {LanguageHandler.getTranslatedText("ATLAS_TRAVEL_IS")}
            </Typography>
            <Typography variant="body1" padding="10px 0">
                {LanguageHandler.getTranslatedText("OUR_MISSION_IS")}
            </Typography>
            <Typography variant="body1" padding="10px 0">
                {LanguageHandler.getTranslatedText("LOOKING_IN_THE_FUTURE")}
            </Typography>
        </Stack>
    );
}

export default Home;
